module.exports = __webpack_public_path__ + "assets/img/crayon15.6e852677.png";